(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        // eslint-disable-next-line no-console
        this.initialState = initialState ? initialState.map(function(row) {
            return row.slice();
        }) : Array.from({
            length: 4
        }, function() {
            return Array(4).fill(0);
        });
        this.board = this.initialState.map(function(row) {
            return row.slice();
        });
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                if (this.status !== "playing") return;
                var oldBoard = this.board.map(function(row) {
                    return row.slice();
                });
                this.board = this.board.map(function(row) {
                    var gained = 0;
                    var clearRow = row.filter(function(v) {
                        return v !== 0;
                    });
                    for(var r = 0; r < clearRow.length - 1; r++)if (clearRow[r] === clearRow[r + 1]) {
                        clearRow[r] *= 2;
                        clearRow[r + 1] = 0;
                        gained += clearRow[r];
                    }
                    _this.score += gained;
                    var result = clearRow.filter(function(v) {
                        return v !== 0;
                    });
                    while(result.length < 4)result.push(0);
                    return result;
                });
                if (this._isBoardChanged(this.board, oldBoard)) this._addNewNumber(this.board);
                this._checkGameStatus();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                if (this.status !== "playing") return;
                var oldBoard = this.board.map(function(row) {
                    return row.slice();
                });
                this.board = this.board.map(function(row) {
                    var gained = 0;
                    var clearRow = row.filter(function(v) {
                        return v !== 0;
                    });
                    for(var r = clearRow.length - 1; r > 0; r--)if (clearRow[r] === clearRow[r - 1]) {
                        clearRow[r] *= 2;
                        clearRow[r - 1] = 0;
                        gained += clearRow[r];
                    }
                    _this.score += gained;
                    var result = clearRow.filter(function(v) {
                        return v !== 0;
                    });
                    while(result.length < 4)result.unshift(0);
                    return result;
                });
                if (this._isBoardChanged(this.board, oldBoard)) this._addNewNumber(this.board);
                this._checkGameStatus();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(col) {
                    var column = _this.board.map(function(row) {
                        return row[col];
                    });
                    var compressedCol = _this._compress(column);
                    _this.score += compressedCol.score;
                    for(var row = 0; row < 4; row++)_this.board[row][col] = compressedCol.column[row];
                };
                if (this.status !== "playing") return;
                var oldBoard = this.board.map(function(row) {
                    return row.slice();
                });
                for(var col = 0; col < 4; col++)_loop(col);
                if (this._isBoardChanged(this.board, oldBoard)) this._addNewNumber(this.board);
                this._checkGameStatus();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(col) {
                    var column = _this.board.map(function(row) {
                        return row[col];
                    }).reverse();
                    var compressedCol = _this._compress(column);
                    _this.score += compressedCol.score;
                    var finalColumn = compressedCol.column.reverse();
                    for(var row = 0; row < 4; row++)_this.board[row][col] = finalColumn[row];
                };
                if (this.status !== "playing") return;
                var oldBoard = this.board.map(function(row) {
                    return row.slice();
                });
                for(var col = 0; col < 4; col++)_loop(col);
                if (this._isBoardChanged(this.board, oldBoard)) this._addNewNumber(this.board);
                this._checkGameStatus();
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return row.slice();
                });
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                if (this.status !== "idle") {
                    this.board = [
                        [
                            0,
                            0,
                            0,
                            0
                        ],
                        [
                            0,
                            0,
                            0,
                            0
                        ],
                        [
                            0,
                            0,
                            0,
                            0
                        ],
                        [
                            0,
                            0,
                            0,
                            0
                        ]
                    ];
                    this.score = 0;
                    this.status = "idle";
                }
                var emptyCells = this._getEmptyCells(this.board);
                if (emptyCells.length >= 2) {
                    this._addNewNumber(this.board);
                    this._addNewNumber(this.board);
                }
                this.status = "playing";
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.board = this.initialState;
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "_getRandomEmptyCell",
            value: function _getRandomEmptyCell(cells) {
                var index = Math.floor(Math.random() * cells.length);
                return cells.splice(index, 1)[0];
            }
        },
        {
            key: "_compress",
            value: function _compress(column) {
                var clearColumn = [];
                var gained = 0;
                for(var i = 0; i < column.length; i++)if (column[i] !== 0) clearColumn.push(column[i]);
                for(var y = 0; y < clearColumn.length - 1; y++)if (clearColumn[y] === clearColumn[y + 1]) {
                    clearColumn[y] *= 2;
                    clearColumn[y + 1] = 0;
                    gained += clearColumn[y];
                }
                var result = clearColumn.filter(function(v) {
                    return v !== 0;
                });
                while(result.length < 4)result.push(0);
                return {
                    column: result,
                    score: gained
                };
            }
        },
        {
            key: "_getEmptyCells",
            value: function _getEmptyCells(board) {
                var emptyCells = [];
                for(var row = 0; row < 4; row++){
                    for(var col = 0; col < 4; col++)if (board[row][col] === 0) emptyCells.push([
                        row,
                        col
                    ]);
                }
                return emptyCells;
            }
        },
        {
            key: "_isBoardFull",
            value: function _isBoardFull(board) {
                return this._getEmptyCells(board).length === 0;
            }
        },
        {
            key: "_isBoardChanged",
            value: function _isBoardChanged(newBoard, oldBoard) {
                return newBoard.some(function(row, rowIndex) {
                    return row.some(function(cell, colIndex) {
                        return cell !== oldBoard[rowIndex][colIndex];
                    });
                });
            }
        },
        {
            key: "_addNewNumber",
            value: function _addNewNumber(board) {
                var emptyCells = this._getEmptyCells(board);
                var newNumber = this._getRandomEmptyCell(emptyCells);
                if (newNumber) {
                    var _newNumber = (0, $efec029548ccee7f$export$71511d61b312f219)(newNumber, 2), row1 = _newNumber[0], col1 = _newNumber[1];
                    board[row1][col1] = Math.random() < 0.9 ? 2 : 4;
                }
            }
        },
        {
            key: "_checkGameStatus",
            value: function _checkGameStatus() {
                var flatBoard = this.board.flat();
                if (flatBoard.includes(2048)) {
                    this.status = "win";
                    return;
                }
                if (flatBoard.includes(0)) return;
                for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
                    var current = this.board[row][col];
                    if (col < 3 && current === this.board[row][col + 1]) return;
                    if (row < 3 && current === this.board[row + 1][col]) return;
                }
                this.status = "lose";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


"use strict";
var $197cd56b15c33885$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($3d28d7f1aac198f5$exports)))();
// Write your code here
var $197cd56b15c33885$var$startButton = document.querySelector(".start");
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$renderBoard($197cd56b15c33885$var$game.getState());
    $197cd56b15c33885$var$startButton.className = "button restart";
    $197cd56b15c33885$var$startButton.textContent = "Restart";
    $197cd56b15c33885$var$updateMessage($197cd56b15c33885$var$game.getStatus());
});
document.addEventListener("keydown", function(e) {
    switch(e.key){
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        default:
            break;
    }
    $197cd56b15c33885$var$renderBoard($197cd56b15c33885$var$game.getState());
    $197cd56b15c33885$var$updateScore($197cd56b15c33885$var$game.getScore());
    $197cd56b15c33885$var$updateMessage($197cd56b15c33885$var$game.getStatus());
});
function $197cd56b15c33885$var$renderBoard(state) {
    var cells = document.querySelectorAll(".field-cell");
    var index = 0;
    for(var row = 0; row < 4; row++)for(var col = 0; col < 4; col++){
        var value = state[row][col];
        var cell = cells[index];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add("field-cell--".concat(value));
        index++;
    }
}
function $197cd56b15c33885$var$updateScore(scores) {
    var score = document.querySelector(".game-score");
    score.textContent = scores;
}
function $197cd56b15c33885$var$updateMessage(gameStatus) {
    var startMessage = document.querySelector(".message-start");
    var winMessage = document.querySelector(".message-win");
    var loseMessage = document.querySelector(".message-lose");
    startMessage.classList.add("hidden");
    winMessage.classList.add("hidden");
    loseMessage.classList.add("hidden");
    switch(gameStatus){
        case "idle":
            startMessage.classList.remove("hidden");
            break;
        case "win":
            winMessage.classList.remove("hidden");
            break;
        case "lose":
            loseMessage.classList.remove("hidden");
            break;
        default:
            break;
    }
}

})();
//# sourceMappingURL=index.be90cf1b.js.map
